import React, {Component} from 'react';
import './Dialogs.min.css';
//import swoosh from'./swoosh.jpg';

class OptionHelpDialog extends Component {
    constructor(props) {
        super(props);
    }
    displayHelp(data, option){
        var title = data.parameters[option].title
        var help = [];
        help.push(<SystemPressureHelp title={title} />);
        help.push(<ModelNumberHelp title={title} />);
        help.push(<ForceRatingHelp title={title} />);
        help.push(<SystemThreadHelp title={title} />);
        help.push(<DispTransducerHelp title={title} />);
        help.push(<DynamicStrokeHelp title={title} />);
        help.push(<BearingDesignHelp title={title} />);
        help.push(<FirstServoHelp title={title} />);
        help.push(<Shutoff1Help title={title} />);
        help.push(<CloseCoupAccumHelp title={title} />);
        help.push(<AccumCertHelp title={title} />);
        help.push(<DeltaPStabHelp title={title} />);
        help.push(<SecondServoHelp title={title} />);
        help.push(<Shutoff2Help title={title} />);
        help.push(<ForceMeasureHelp title={title} />);
        help.push(<BaseEndTypeHelp title={title} />);
        help.push(<RodEndTypeHelp title={title} />);
        help.push(<HoistRingRestPadHelp title={title} />);
        return help[option];
    }
    render() {
        return (
            <div id="dlg_help_sysPressure" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Product Option Help</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        { this.displayHelp(this.props.data, this.props.option) }
                        <div id="dlg_quote_btn" className="dlg_btn" onClick={() => this.props.onClick(null)}>OK</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OptionHelpDialog;


class SystemPressureHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Maximum working pressure of your hydraulic system. Available in 21 MPa (3000 psi) and 28 MPa (4000 psi) configurations.
                Note:  Choice of system pressure may affect force rating for each specific model number below.</p>
            </div>
        );
    }
}

class ModelNumberHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>The chart below gives each model number, along with their rod diameter and corresponding force rating</p>
                <p><b>Note:</b> The 244 Series actuators are double ended, meaning they have equal working area, resulting in an equal force rating in both tension and compression.</p>

                <table className="dlg_Htable flush-left" cellPadding="5">
                    <tbody>
                         <tr className="dlg_header_row">
                            <td colSpan="9" className="dlg_cell">244 Actuator Specifications</td>
                        </tr>
                        <tr className="dlg_subHeader_row">
                            <td colSpan="1" className="dlg_cell">Model Number</td>
                            <td colSpan="2" className="dlg_cell">Rod Diameter</td>
                            <td colSpan="2" className="dlg_cell">Force Rating</td>
                            <td colSpan="2" className="dlg_cell">Hydraulic Cushion</td>
                        </tr>
                        <tr className="dlg_labels_row">
                            <td colSpan="1" className="dlg_cell"></td>
                            <td colSpan="1" className="dlg_cell">mm</td>
                            <td colSpan="1" className="dlg_cell">in</td>
                            <td colSpan="1" className="dlg_cell">kN</td>
                            <td colSpan="1" className="dlg_cell">kip</td>
                            <td colSpan="1" className="dlg_cell">mm</td>
                            <td colSpan="1" className="dlg_cell">in</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.11</td>
                            <td colSpan="1" className="dlg_cell">44.5</td>
                            <td colSpan="1" className="dlg_cell">1.75</td>
                            <td colSpan="1" className="dlg_cell">15</td>
                            <td colSpan="1" className="dlg_cell">3.3</td>
                            <td colSpan="1" className="dlg_cell">15.2</td>
                            <td colSpan="1" className="dlg_cell">0.60</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.12</td>
                            <td colSpan="1" className="dlg_cell">44.5</td>
                            <td colSpan="1" className="dlg_cell">1.75</td>
                            <td colSpan="1" className="dlg_cell">25</td>
                            <td colSpan="1" className="dlg_cell">5.5</td>
                            <td colSpan="1" className="dlg_cell">15.2</td>
                            <td colSpan="1" className="dlg_cell">0.60</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.21</td>
                            <td colSpan="1" className="dlg_cell">69.9</td>
                            <td colSpan="1" className="dlg_cell">2.75</td>
                            <td colSpan="1" className="dlg_cell">50</td>
                            <td colSpan="1" className="dlg_cell">11</td>
                            <td colSpan="1" className="dlg_cell">10.2</td>
                            <td colSpan="1" className="dlg_cell">0.40</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.20</td>
                            <td colSpan="1" className="dlg_cell">69.9</td>
                            <td colSpan="1" className="dlg_cell">2.75</td>
                            <td colSpan="1" className="dlg_cell">67</td>
                            <td colSpan="1" className="dlg_cell">15</td>
                            <td colSpan="1" className="dlg_cell">10.2</td>
                            <td colSpan="1" className="dlg_cell">0.40</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.22</td>
                            <td colSpan="1" className="dlg_cell">69.9</td>
                            <td colSpan="1" className="dlg_cell">2.75</td>
                            <td colSpan="1" className="dlg_cell">100</td>
                            <td colSpan="1" className="dlg_cell">22</td>
                            <td colSpan="1" className="dlg_cell">7.6</td>
                            <td colSpan="1" className="dlg_cell">0.30</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.23</td>
                            <td colSpan="1"  className="dlg_cell">69.9</td>
                            <td colSpan="1"  className="dlg_cell">2.75</td>
                            <td colSpan="1"  className="dlg_cell">150</td>
                            <td colSpan="1"  className="dlg_cell">35</td>
                            <td colSpan="1" className="dlg_cell">6.4</td>
                            <td colSpan="1" className="dlg_cell">0.25</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.31</td>
                            <td colSpan="1" className="dlg_cell">95.3</td>
                            <td colSpan="1" className="dlg_cell">3.75</td>
                            <td colSpan="1" className="dlg_cell">250</td>
                            <td colSpan="1" className="dlg_cell">55</td>
                            <td colSpan="1" className="dlg_cell">5.1</td>
                            <td colSpan="1" className="dlg_cell">0.20</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.41</td>
                            <td colSpan="1" className="dlg_cell">133.4</td>
                            <td colSpan="1" className="dlg_cell">5.25</td>
                            <td colSpan="1" className="dlg_cell">500</td>
                            <td colSpan="1" className="dlg_cell">110</td>
                            <td colSpan="1" className="dlg_cell">-</td>
                            <td colSpan="1" className="dlg_cell">-</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.51</td>
                            <td colSpan="1" className="dlg_cell">152.4</td>
                            <td colSpan="1" className="dlg_cell">6.0</td>
                            <td colSpan="1" className="dlg_cell">1000</td>
                            <td colSpan="1" className="dlg_cell">220</td>
                            <td colSpan="1" className="dlg_cell">-</td>
                            <td colSpan="1" className="dlg_cell">-</td>
                        </tr>
                    </tbody>
                </table>

                <p>All 201, 242, and 244 actuators are fatigue-rated to their full force rating.
                This rating, however, was established assuming minimal overhead for rod friction and losses due to backpressure check valves on HDMs, HSMs and HPUs. General recommendations for actuator sizing would be as follows:</p>
                <ul>
                    <li>For static applications, recommended force requirement should be below 95% of the force rating, to ensure that loads can be met even with some actuator friction and system losses.</li>
                    <li>For dynamic applications, recommend force requirement should be below 80% of the force rating, to ensure that loads can be met dynamically with appropriate servovalve sizing.</li>
                </ul>
            </div>
        );
    }
}

class ForceRatingHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Force Rating is listed here for your informational benefit.  This field is populated based on the selection made above in the “SYSTEM THREAD TYPE” and “MODEL NUMBER” fields.</p>
            </div>
        );
    }
}

class SystemThreadHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>System Thread Type allows you to select between either Metric or US Customary.</p>
            </div>
        );
    }
}

class DispTransducerHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Series 244 actuators are equipped with LVDT for displacement measurements. Custom 244 actuators available with Temposonic options. Contact MTS for additional information.</p>
            </div>
        );
    }
}

class DynamicStrokeHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>For standard 244 actuators, the stroke is given by the maximum usable piston rod travel under dynamic applications. The Hydraulic Cushion length is in addition to the listed stroke. </p>
                <img className="medium" src="images/244stroke.jpg" />
            </div>
        );
    }
}

class BearingDesignHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p><u><b>Polymer Glide Style:</b></u> An integral bonded bearing design bonds high-capacity polymer piston rod bearings directly to the end cap, providing high side load tolerance and excellent resistance to galling and seizure.</p>
                <p><u><b>Hydrostatic Bearing:</b></u>Pressure-centering bearings can support continuous high-speed operation under heavy side loads.</p>
            </div>
        );
    }
}

class FirstServoHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Servovalve model and size selection based on flow rating.</p>

            <table className="dlg_Htable flush-left" cellPadding="5">
                <tbody>
                        <tr className="dlg_header_row">
                            <td colSpan="9" className="dlg_cell">244 Cylinder Manifold Dimensions</td>
                        </tr>
                        <tr className="dlg_subHeader_row">
                            <td colSpan="1" className="dlg_cell">Model Number</td>
                            <td colSpan="2" className="dlg_cell">Maximum Recommended MTS Servovalve Size*</td>

                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.11</td>
                            <td colSpan="1" className="dlg_cell">256.05</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.12</td>
                            <td colSpan="1" className="dlg_cell">256.05</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.20</td>
                            <td colSpan="1" className="dlg_cell">256.09</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.21</td>
                            <td colSpan="1" className="dlg_cell">256.09</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.22</td>
                            <td colSpan="1" className="dlg_cell">256.09</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.23</td>
                            <td colSpan="1"  className="dlg_cell">256.09</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.31</td>
                            <td colSpan="1" className="dlg_cell">256.09</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.41</td>
                            <td colSpan="1" className="dlg_cell">256.09</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">244.51</td>
                            <td colSpan="1" className="dlg_cell">256.09</td>
                        </tr>
                 </tbody>
            </table>
            <p>*Maximum valve size could result in cylinder damage if a maximum piston velocity end cap strike occurs. Attached mass and piston velocity need to be considered. MTS offers custom Hydraulic Cushions options to help absorb high impact energy. Contact MTS for additional information.</p>
        </div>

        );
    }
}

class Shutoff1Help extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Manual shut-off available for the Series 252 valves.</p>

                <p>Commonly used on actuators with dual servovalves, the shut off can isolate a valve from the system. This feature may be desirable in low flow applications where the performance of both servovalves is not required.</p> 

                <p>The manual shut off is also useful for maintenance, to prevent excess oil leakage when changing or removing servovalves.</p>
            </div>
        );
    }
}

class CloseCoupAccumHelp extends Component {
constructor(props) {
    super(props);
}
render() {
    return (
        <div className="dlg_prod_help">
            <span className="dlg_title_txt">{this.props.title}</span>
            <p>Manifold mounted accumulators offer superior performance for high dynamic testing. Selection offered with Series 256 valves.</p>
            <img className="medium" src="images/244cca.jpg" />
        </div>
    );
}
}

class AccumCertHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p><u><b>MTS Standard:</b></u> Typical for use in USA</p>
                <p><u><b>CE:</b></u> European Certification</p>
                <p><u><b>KHK:</b></u> Japanese Certification</p>
                <p><u><b>CRN:</b></u> Canadian Certification</p>
                <p><u><b>CE:</b></u> China Label</p>
            </div>
        );
    }
}

class DeltaPStabHelp extends Component {
constructor(props) {
    super(props);
}
render() {
    return (
        <div className="dlg_prod_help">
            <span className="dlg_title_txt">{this.props.title}</span>
            <p>This selection is only applicable if you have selected a Series 256 Servovalve. Delta-P Stabilization adds a differential pressure transducer for the express purpose to aid in the PID closed loop tuning of the actuator.</p>
        </div>
    );
}
}

class SecondServoHelp extends Component {
constructor(props) {
    super(props);
}
render() {
    return (
        <div className="dlg_prod_help">
            <span className="dlg_title_txt">{this.props.title}</span>
            <p>This selection is available if the first servovalve selection was a Series 252 valve. It allows for the selection of a second Series 252 valve to achieve higher flow rates. If only a single 252 servovalve is required, select the Pressure Rated Cover Plate.</p>
        </div>
    );
}
}

class Shutoff2Help extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Manual shut-off available for the Series 252 valves.</p>

                <p>Commonly used on actuators with dual servovalves, the shut off can isolate a valve from the system. This feature may be desirable in low flow applications where the performance of both servovalves is not required.</p> 

                <p>The manual shut off is also useful for maintenance, to prevent excess oil leakage when changing or removing servovalves.</p>
            </div>
        );
    }
}

class ForceMeasureHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p><u><b>Load Cell</b></u> - Single Bridge - Fatigue Sized:  Standard load cell size, sufficient to handle all actuator use cases without a fatigue failure. Can be calibrated out to 150% of force rating if necessary. </p>
                <p><u><b>Dual Bridge:</b></u>   Used in applications where redundancy of the load measurement is required.</p>
            </div>
        );
    }
}

class BaseEndTypeHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>

                <p><u><b>Adjustable Swivel:</b></u>  Offered as a high-performance option for dynamic applications. The adjustable swivel includes backlash adjustment to enable continuous close pe mvmkvfit bearing tolerance, minimizing bearing backlash for optimal testing speed and accuracy. </p>
                <p><u><b>Pedestal Base:</b></u>  Offered as a stationary attachment option for rear mounting.</p>

                <div className="dlg_sideByside_images">
                    <div className="dlg_row">
                        <div className="dlg_cell1">
                            <div className="dlg_cell_text">Adjustable Swivel</div>
                            <img className="medium" src="images/244adjustable_swivel.jpg" />
                         </div>
                        <div className="dlg_cell2">
                            <div className="dlg_cell_text">Pedestal Base</div>
                            <img className="medium" src="images/244pedestal.jpg" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class RodEndTypeHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>

                <p><u><b>Adjustable Swivel:</b></u>  Offered as a high-performance option for dynamic applications. The adjustable swivel includes backlash adjustment to enable continuous close pe mvmkvfit bearing tolerance, minimizing bearing backlash for optimal testing speed and accuracy. </p>

                <div className="dlg_sideByside_images">

                    <div className="dlg_row">
                            <img className="small" src="images/244adjustable_swivel.jpg" />
                    </div>

                </div>
            </div>
        );
    }
}

class HoistRingRestPadHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p><u><b>Hoist Rings:</b></u> Swiveling and CE-Rated lifting device.</p>
                <p><u><b>Rest Pads:</b></u> High durometer urethane pads for protection of actuator finish while in storage or transit.</p>
                <img className="medium" src="images/hoist_ring_rest_pad.jpg" />
                <p>Note:  Hoist rings and rest pad option available on actuator size 244.22 and larger.</p>
            </div>
        );
    }
}